import { EnvironmentName } from './models/environment-name.model'

export const environment = {
  name: EnvironmentName.STAGING,
  production: false,
  server_running: false,
  apiBaseURL: 'https://api-staging.one.store',
  widgetURL: 'https://cdn-staging.one.store/javascript/dist/1.0/jcr-widget.js',
  widgetPreviewURL: 'https://cdn-staging.one.store/javascript/dist/1.0/jcr-widget-preview.js',
  adminPortalBaseURL: 'https://admin-staging.one.store',
  hostname: 'app-staging.one.store',
  title: 'Proof Factor | Increase Your Conversion',
  shopify: {
    clientId: '',
    embedded: false
  },
  firebase: {
    apiKey: 'AIzaSyCGIsGZ7F-XZwALeeq4GSKfFRqxxaPnZ5U',
    authDomain: 'proof-factor-dashboard-staging.firebaseapp.com',
    databaseURL: 'https://proof-factor-dashboard-staging.firebaseio.com',
    projectId: 'proof-factor-dashboard-staging',
    storageBucket: 'cdn-staging.prooffactor.com',
    messagingSenderId: '1096618791622',
    cdnUrl: 'cdn-staging.one.store',
  },
  stripe: {
    publishableKey: 'pk_test_8h4Ha4Fb7REVxWp5JtvW2GF1',
  },

  signUp: {
    autoGenerateCredentials: false,
    baseEmail: 'staging@prooffactor.com',
    basePass: '123456',
  },

  gettingStarted: {
    active: true,
    detectPollingInterval: 4000,
  },
  // fullStoryOrg: '17DNWX',
  logRocketID: 'morpheus/one-develop',
  googleAnaltyicsToken: 'UA-123323891-2',
  segmentApiKey: 'mpAQfvC7cPh1g4stReE2jLuc0QfnFleW',
  hCaptchaSiteKey: 'cd20bb80-c302-4982-a259-f753cf14e77d',
  jotFormApiKey: 'adec81eea78a10f70896bdbd5521d53f',
  shopifyEmbedPixelId: '8c78e353-26a3-4e2f-9240-6d48b98d8dd9'
}
